import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  feedCommentList,
  feedLikeList,
  feedLikePost,
  feedPostComment,
  feedPostCommentDelete,
} from "../Services/DashboardServices";
import { TostMsg } from "../../../../App";
import moment from "moment";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import Commnent from "../../../../Services/Comment/comment";
import { PostDate } from "../CommonComponents/PostDate";
import { useDispatch } from "react-redux";
import { setLeaveRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import TosterService from "../../../../Services/Toster-Service/TosterService";

let DeleteId;
const defaultImage = "/images/placeholder_profile.png";
export const FeedDetailComment = memo(
  ({ Feedlst, Index, feedGUID, onPassLikeResponse }) => {
    const feedlst = Feedlst;
    const FeedGUID = feedGUID;
    const toster = useContext(TostMsg);
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [feedText, setFeedText] = useState("");
    const [Isloading, setIsloading] = useState(false);
    const [feedComment, setFeedComment] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [openIndex, setOpenIndex] = useState(null);
    const divRefs = useRef([]);
    const [likeLoader, setLikeLoader] = useState(false);
    const [commentType, setCommentType] = useState(null);
    const [openCommentId, setOpenCommentId] = useState(null);
    const [commentedList, setCommentedList] = useState([]);
    const popupRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const dispatch = useDispatch();
    useEffect(() => {
      FeedCommentList();
      fetchEmployeeData();

    }, []);

    async function FeedLikeListData(item) {
      setCommentedList([]);
      const body = {
        LoggedInUserId: userDetails?.EmpId,
        FeedId: Feedlst?.Id,
        FeedGUID: "",
        CommentId: item?.Id,//10198,
        pageNumber: 1,
        pageSize: 1000000,
      };
      try {
        let LikeList = await feedLikeList(body);
        setCommentedList(LikeList?.Data);
      } catch (error) {
        TosterService.current.error(ERROR_LIST?.FeedLikePostOnFeedDetails);
      }
    }



    useEffect(() => {
      function handleClickOutside(event) {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          setIsOpen(false); // close popup
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);


    const renderCommentText = (text) => {
      const mentionRegex = /@\w+/g;
      const hashtagRegex = /#\w+/g;
      let postMention = text?.PostMentions;
      let FeedText = text?.Comment;

      let newText = FeedText?.replace(mentionRegex, (mention) => {
        let matchedMention = postMention?.find(
          (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention
        );
        if (!matchedMention) {
          return mention.replace("@", "");
        }
        return `<a href="/Profile/${matchedMention.MentionedGuid}">${matchedMention.MentionedName}</a>`;
      });

      newText = newText?.replace(hashtagRegex, (hashtag) => {
        return `<a style="color: #c4c6c7">${hashtag}</a>`;
      });

      return { __html: newText };
    };

    const renderParentCommentText = (text) => {
      const mentionRegex = /@\w+/g;
      const hashtagRegex = /#\w+/g;
      let postMention = text?.PostMentions;
      let FeedCommentText = text?.ParentComment;

      let newText = FeedCommentText?.replace(mentionRegex, (mention) => {
        let matchedMention = postMention?.find(
          (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention
        );
        if (!matchedMention) {
          return mention.replace("@", "");
        }
        return `<a href="/Profile/${matchedMention.MentionedUserId}">${matchedMention.MentionedName}</a>`;
      });

      newText = newText?.replace(hashtagRegex, (hashtag) => {
        return `<a style="color: #c4c6c7">${hashtag}</a>`;
      });

      return { __html: newText };
    };

    async function CommentPost(lst) {
      setCommentList([]);
      const updatedFeedList = feedComment?.map((item) => {
        if (item.Id !== lst.Id) return item;
        let updatedItem = { ...item };
        if (lst.IsLiked == 1) {
          updatedItem = {
            ...item,
            IsLiked: Math.max(0, lst.IsLiked - 1),
            LikesCount: Math.max(0, lst.LikesCount - 1),
          };
        } else {
          updatedItem = {
            ...item,
            IsLiked: lst.IsLiked + 1,
            LikesCount: lst.LikesCount + 1,
          };
        }
        return updatedItem;
      });
      setFeedComment(updatedFeedList);
      let isLike = lst.MyReaction !== "Like";
      const body = {
        FeedId: Number(lst.FeedId),
        CommentId: lst.Id,
        ReactionById: userDetails?.EmpId,
        ReactionTypeId: 101,
        Reaction: "Like",
        IsLike: isLike,
      };
      try {
        await feedLikePost(body);
      } catch (error) {
        toster.current.warn(ERROR_LIST.DashboardLike);
      }
    }

    //Get Employee List from EmployeeList service
    async function fetchEmployeeData() {
      var params = {
        OrganisationId: userDetails?.OrgId,
        LoggedInEmployeeId: userDetails?.EmpId,
        IsDirectReportOrHierarchy: 0,
        SearchText: "",
        FollowersOnly: 0,
        FollowingsOnly: 0,
        IsExEmployeesAlso: 0,
        pageNumber: 1,
        pageSize: 1000000,
        EmployeeId: 0,
      };
      try {
        let employeesList = await getEmployeeList(params);
        setEmployee(employeesList.Data);
      } catch (error) {
        toster.current.error(ERROR_LIST?.EmployeeListOnFeedDetails);
      }
    }

    // For Comment List of Feed service.
    async function FeedCommentList() {
      const body = {
        LoggedInUserId: userDetails?.EmpId,
        FeedId: 0,
        FeedGUID: FeedGUID,
        pageNumber: 1,
        pageSize: 10000000,
      };
      try {
        let FeedComment = await feedCommentList(body);
        setFeedComment(FeedComment?.Data);
        dispatch(setLeaveRequestData(FeedComment?.Data?.length));
      } catch (error) {
        toster.current.warn(ERROR_LIST.DashboardLike);
      }
    }

    const handleImageError = useCallback((event) => {
      event.target.src = defaultImage;
    }, []);

    // For Comment, This feature allows you to respond to comments and messages directly from the story.
    async function FeedPostComment(
      CommentData,
      mentionedArr,
      CommentText,
      type
    ) {
      let ParentCommentId;
      let NewMentionedArr = [];
      let CommentId;
      if (type == 2) {
        ParentCommentId = CommentData?.Id;
        CommentId = 0;
        NewMentionedArr = mentionedArr?.map((el) => {
          let newCommentId = {
            ...el,
            CommentId: ParentCommentId,
          };
          return newCommentId;
        });
      } else if (type == 0) {
        CommentId = 0;
        ParentCommentId = 0;
        NewMentionedArr = mentionedArr;
      } else {
        CommentId = CommentData?.Id;
        NewMentionedArr = mentionedArr;
        ParentCommentId = CommentData?.ParentCommentId;
      }
      const body = {
        Id: CommentId,
        FeedId: Number(feedlst?.Id),
        EmpId: userDetails?.EmpId,
        ParentCommentId: ParentCommentId,
        Comment: CommentText,
        PostMentions: NewMentionedArr,
      };
      try {
        await feedPostComment(body);
        FeedCommentList();
        setFeedText("");
        setCommentType(0);
        setLikeLoader(false);
      } catch (error) {
        toster.current.warn(ERROR_LIST.DashboardComment);
        setLikeLoader(false);
      }
    }

    //Delete the Feed.
    async function FeedPostCommentDelete(deleteId) {
      if (deleteId) {
        let body = {
          Id: deleteId,
        };
        setIsloading(true);
        try {
          await feedPostCommentDelete(body);
          setIsloading(false);
          FeedCommentList();
          return false;
        } catch (error) {
          setIsloading(false);
        }
      }
    }
    const handleClickOutside = (event) => {
      if (
        divRefs?.current?.every((ref) => !ref || !ref.contains(event?.target))
      ) {
        setOpenIndex(null);
      }
    };
    useEffect(() => {
      if (openIndex !== null) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [openIndex]);

    const scrolltoSubmit = useRef(null);
    const handleClick = () => {
      ;
      scrolltoSubmit?.current?.scrollIntoView({ behavior: "smooth" });
    };

    const handleToggle = (comment) => {
      handleClick();
      setFeedText(comment?.Comment);
      setCommentList(comment);
      setCommentType(2);
    };

    const [commentList, setCommentList] = useState(null);
    const EditComment = (comment) => {
      setCommentType(1);
      setCommentList(comment);
    };

    function closeQuets() {
      setCommentType(0);
      setFeedText("");
    }

    const scrollToParent = (parentId) => {
      const element = document.getElementById(`comment-${parentId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        // Optionally highlight the element
        element.classList.add("highlight-comment");
        setTimeout(() => {
          element.classList.remove("highlight-comment");
        }, 2000);
      }
    };

    return (
      <>
        <div className="card-footer d-block commentdiv">
          <div className="quote-reply">
            {commentType != 1 ? (
              <>
                {feedText && (
                  <div className="">
                    <p className="feed-quotes">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="absolute top-2 right-2 w-5 h-5 cursor-pointer text-red-500 hover:text-red-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        width={20}
                        style={{ cursor: "pointer" }}
                        onClick={() => closeQuets()}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                      <span className="quote-to">
                        <b>{commentList?.CommentBy} </b>
                        {moment(commentList?.ModifiedDate).format(
                          "MMMM Do YYYY, h:mm:ss a"
                        )}
                      </span>
                      <br />
                      <p className="reply-on">{feedText}</p>
                    </p>
                  </div>
                )}
              </>
            ) : (
              ""
            )}
            <a>
              <div className="send-output">
                <img
                  className="pro-img"
                  src={userDetails?.ProfileImage || defaultImage}
                  onError={handleImageError}
                  data-user-popover="1"
                  alt=""
                  ref={scrolltoSubmit}
                />
                <Commnent
                  sendCommentData={FeedPostComment}
                  reciveCommentData={commentList}
                  employeesList={employee}
                  commentType={commentType}
                  loader={likeLoader}
                />
              </div>
            </a>
          </div>
          {feedComment?.map((commentlst, index) =>
            commentlst?.ParentComment ?
              (
                <div
                  key={index}
                  className="quote-comment"
                  data-parent-id={commentlst?.ParentCommentId}
                >
                  <div className="feed-comments-quote" onClick={() => scrollToParent(commentlst?.ParentCommentId)}>
                    <img
                      src={commentlst?.ParentCommentByProfilePic || defaultImage}
                      onError={handleImageError}
                      title={commentlst?.ParentCommentBy}
                      data-user-popover="1"
                      alt=""
                    />
                    <div className="comment-textdiv bg-light rounded-start-top-0 rounded">
                      <div className="d-flex justify-content-between">
                        <h6 className="mb-1">
                          <Link to={`/Profile/${commentlst?.ParentCommentGUID}`}>
                            {commentlst?.ParentCommentBy}
                          </Link>
                        </h6>
                        <small className="ms-2">
                          <PostDate LastCommentDate={commentlst?.ModifiedDate} />
                        </small>
                      </div>
                      <p
                        className="small break-text"
                        dangerouslySetInnerHTML={renderParentCommentText(
                          commentlst
                        )}
                      ></p>
                    </div>
                  </div>
                  <div className="quotecomment-reply">
                    <img
                      src={commentlst?.CommentByProfilePic || defaultImage}
                      onError={handleImageError}
                      title={commentlst?.CommentBy}
                      data-user-popover="1"
                      alt=""
                    />
                    <div className="comment-textdiv bg-light rounded-start-top-0 rounded">
                      <div className="d-flex justify-content-between">
                        <h6 className="mb-1">
                          <Link to={`/Profile/${commentlst?.CommentByGUID}`}>
                            {commentlst?.CommentBy}
                          </Link>
                        </h6>
                        <small className="ms-2">
                          <PostDate LastCommentDate={commentlst?.ModifiedDate} />
                        </small>
                      </div>
                      <p
                        dangerouslySetInnerHTML={renderCommentText(commentlst)}
                        className="small break-text"
                      ></p>
                      <p className="like-button">
                        {commentlst?.IsLiked ? (
                          <a className="hover-like-box">
                            <svg
                              onClick={() => CommentPost(commentlst)}
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-heart-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                              />
                            </svg>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                FeedLikeListData(commentlst);
                                setOpenCommentId(commentlst.Id);
                                setIsOpen(true);
                              }}
                            >
                              {commentlst?.LikesCount == 1
                                ? ' ' + commentlst?.LikesCount + ' Like'
                                : ""}
                            </a>

                            {(commentedList?.length >= 1 && openCommentId === commentlst.Id && isOpen) ? (
                              <div className="hover-like-area" ref={popupRef}>
                                <ul>
                                  {commentedList?.map((item, idx) => (
                                    <li key={idx}>
                                      <a>
                                        <img
                                          src={item?.LikedByProfilePic}
                                          className="user-like-img"
                                        />
                                        <span>
                                          {item?.LikedBy}
                                        </span>
                                      </a>
                                    </li>))}
                                </ul>
                              </div>) : ('')}

                          </a>
                        ) : (
                          <a >
                            <a >
                              <i onClick={() => CommentPost(commentlst)} className="fa fa-heart-o like-button"></i>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  FeedLikeListData(commentlst);
                                  setOpenCommentId(commentlst.Id);
                                  setIsOpen(true);
                                }}
                              >
                                {commentlst?.LikesCount >= 1
                                  ? ' ' + commentlst?.LikesCount + ' Like'
                                  : ""}
                                {/* {commentlst?.LikesCount} Like */}
                              </a>
                            </a>
                            {(commentedList?.length >= 1 && openCommentId === commentlst.Id && isOpen) ? (
                              <div className="hover-like-area" ref={popupRef}>
                                <ul>
                                  {commentedList?.map((item, idx) => (
                                    <li key={idx}>
                                      <a>
                                        <img
                                          src={item?.LikedByProfilePic}
                                          className="user-like-img"
                                        />
                                        <span>
                                          {item?.LikedBy}
                                        </span>
                                      </a>
                                    </li>))}
                                </ul>
                              </div>) : ('')}
                          </a>
                        )}
                        <a>
                          <a className="atag"></a>
                        </a>
                        <span className="like-overlay"></span>
                        <a onClick={() => handleToggle(commentlst)}>
                          &nbsp;  <i className="fa fa-quote-right" aria-hidden="true"></i>
                          <a className="">Quote</a>
                        </a>
                        <span className="like-overlay"></span>
                      </p>
                    </div>
                  </div>
                  {userDetails?.EmpId == commentlst?.EmpId && (
                    <div className="feed-actions">
                      <img
                        src="/images/org-img/delete.png"
                        onClick={() => FeedPostCommentDelete(commentlst?.Id)}
                        className="feed-comment-delete"
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-edu"
                      />
                      <img
                        src="/images/org-img/edit.png"
                        className="feed-comment-edit"
                        title="Edit"
                        data-bs-toggle="modal"
                        data-bs-target="#add-education"
                        onClick={() => {
                          EditComment(commentlst);
                          handleClick();
                        }}
                      />
                    </div>
                  )}
                </div>
              ) :
              (
                <div
                  key={index}
                  className="feed-comments-bottomdiv"
                  id={`comment-${commentlst?.Id}`}
                >
                  <img
                    src={commentlst?.CommentByProfilePic || defaultImage}
                    onError={handleImageError}
                    title={commentlst?.CommentBy}
                    data-user-popover="1"
                    alt=""
                  />
                  <div className="comment-textdiv bg-light rounded-start-top-0 rounded">
                    <div className="d-flex justify-content-between">
                      <h6 className="mb-1">
                        <Link to={`/Profile/${commentlst?.CommentByGUID}`}>
                          {commentlst?.CommentBy}
                        </Link>
                      </h6>
                      <small className="ms-2">
                        <PostDate LastCommentDate={commentlst?.ModifiedDate} />
                      </small>
                    </div>
                    <p
                      dangerouslySetInnerHTML={renderCommentText(commentlst)}
                      className="small break-text"
                    ></p>

                    <p className="like-button">
                      {commentlst?.IsLiked ? (
                        <a className="hover-like-box">
                          <svg
                            onClick={() => CommentPost(commentlst)}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-heart-fill"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                            />
                          </svg>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              FeedLikeListData(commentlst);
                              setOpenCommentId(commentlst.Id);
                              setIsOpen(true);
                            }}
                          >
                            {commentlst?.LikesCount == 1
                              ? ' ' + commentlst?.LikesCount + ' Like'
                              : ''}
                            {commentlst?.LikesCount >= 2 &&
                              ' ' + commentlst?.LikesCount + ' Likes'}
                          </a>

                          {(commentedList?.length >= 1 && openCommentId === commentlst.Id && isOpen) ? (
                            <div className="hover-like-area" ref={popupRef}>
                              <ul>
                                {commentedList?.map((item, idx) => (
                                  <li key={idx}>
                                    <a>
                                      <img
                                        src={item?.LikedByProfilePic}
                                        className="user-like-img"
                                      />
                                      <span>
                                        {item?.LikedBy}
                                      </span>
                                    </a>
                                  </li>))}
                              </ul>
                            </div>) : ('')}
                        </a>
                      ) : (
                        <a >
                          <a >
                            <i onClick={() => CommentPost(commentlst)} className="fa fa-heart-o like-button"></i>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                FeedLikeListData(commentlst);
                                setOpenCommentId(commentlst.Id);
                                setIsOpen(true);
                              }}
                            >
                              {commentlst?.LikesCount == 1
                                ? ' ' + commentlst?.LikesCount + ' Like'
                                : ''}
                              {commentlst?.LikesCount >= 2 &&
                                ' ' + commentlst?.LikesCount + ' Likes'}
                            </a>
                            {/* {commentedList?.length} */}
                          </a>
                          {(commentedList?.length >= 1 && openCommentId === commentlst.Id && isOpen) ? (
                            <div className="hover-like-area" ref={popupRef}>
                              <ul>
                                {commentedList?.map((item, idx) => (
                                  <li key={idx}>
                                    <a>
                                      <img
                                        src={item?.LikedByProfilePic}
                                        className="user-like-img"
                                      />
                                      <span>
                                        {item?.LikedBy}
                                      </span>
                                    </a>
                                  </li>))}
                              </ul>
                            </div>) : ('')}
                        </a>

                      )}
                      <a>
                        <a className="atag"></a>
                      </a>
                      <span className="like-overlay"></span>
                      <a onClick={() => handleToggle(commentlst)}>
                        &nbsp;  <i className="fa fa-quote-right" aria-hidden="true"></i>
                          <a className="atag">Quote</a>
                      </a>
                      <span className="like-overlay"></span>
                    </p>
                  </div>
                  {userDetails?.EmpId == commentlst?.EmpId && (
                    <div className="feed-actions">
                      <img
                        src="/images/org-img/delete.png"
                        onClick={() => FeedPostCommentDelete(commentlst?.Id)}
                        className="feed-comment-delete"
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-edu"
                      />
                      <img
                        src="/images/org-img/edit.png"
                        onClick={() => {
                          EditComment(commentlst);
                          handleClick();
                        }}
                        className="feed-comment-edit"
                        title="Edit"
                        data-bs-toggle="modal"
                        data-bs-target="#add-education"
                      />
                    </div>
                  )}
                </div>
              )
          )}
        </div>
      </>
    );
  }
);
